import React from 'react';
import { useSelector } from 'react-redux';
import { StoreState } from '../../../types/store.type';
import { UnitPanel } from '../../../components';
import { TranslationUtils, SmartEmailFieldEnricher, SmartPhoneFieldEnricher } from '../../../utils';
import '../styles.scss';

export const RequestCancellation: React.FC = () => {
    const trip = useSelector((store: StoreState) => store.trip);
    const { unit, reservation } = trip;

    if (!unit) {
        return null;
    }

    const propertyManagement = unit.pms_data?.property_management;

    const textKey =
        propertyManagement?.email && propertyManagement?.phone
            ? 'pal_cancellation_contact_text'
            : propertyManagement?.email
            ? 'pal_cancellation_contact_text_email_only'
            : 'pal_cancellation_contact_text_phone_only';

    const isFranchiseContactDataAvailable = !!propertyManagement?.email || !!propertyManagement?.phone;

    return (
        <React.Fragment>
            <div>
                <h1 tabIndex={0} className="heading-large page-title">
                    {TranslationUtils.get('request_cancellation')}
                </h1>

                <UnitPanel />

                {reservation?.cancellation_policy_text && (
                    <div className="pal-section">
                        <div className="pal-section__title">
                            <span className="page-subtitle" tabIndex={0}>
                                {TranslationUtils.get('review_cancellation_policy')}
                            </span>
                        </div>
                        <div
                            className="body-regular"
                            tabIndex={0}
                            dangerouslySetInnerHTML={{
                                __html: reservation.cancellation_policy_text,
                            }}
                        />
                    </div>
                )}
                {isFranchiseContactDataAvailable && (
                    <>
                        <div className="pal-section"></div>
                        <div className="pal-section__title">
                            <span className="page-subtitle" tabIndex={0}>
                                {TranslationUtils.get('cancel_your_reservation')}
                            </span>
                        </div>
                        <span
                            className="body-regular"
                            tabIndex={0}
                            dangerouslySetInnerHTML={{
                                __html: TranslationUtils.get(textKey, {
                                    name: propertyManagement?.name ?? '',
                                    email: SmartEmailFieldEnricher.from(propertyManagement?.email ?? undefined, 'html')?.toString(),
                                    phoneNumber: SmartPhoneFieldEnricher.from(propertyManagement?.phone ?? undefined, 'html')?.toString(),
                                }),
                            }}
                        />
                    </>
                )}
            </div>
        </React.Fragment>
    );
};
